<template>
    <div class="option-content full-width option-upload-content">
        <div class="packet-row packet-checkbox">
            <label for="carrier-1" class="custom-radio-wrap">
                {{ $helper.trans('Call_courier') }}
                <input type="radio" v-model="$store.state.carrierInfo.callCarrier" :value="1" id="carrier-1">
                <span class="checkmark"></span>
            </label>
            <label for="carrier-2" class="custom-radio-wrap">
                {{ $helper.trans('I_will_bring_the_package_to_the_UPS_office') }}
                <input type="radio" v-model="$store.state.carrierInfo.callCarrier" :value="0" id="carrier-2">
                <span class="checkmark"></span>
            </label>
            <div v-show="$store.state.courierAlreadyCalled">
                <label for="carrier-3" class="custom-radio-wrap d-block">
                    {{ $helper.trans('Courier_already_called') }}
                    <input type="radio" v-model="$store.state.carrierInfo.callCarrier" :value="2" id="carrier-3">
                    <span class="checkmark"></span>
                    <br>
                    <b class="d-block mt-2" v-if="!$store.state.carrierInfo.multiPickUpAddresses">
                        {{ $store.state.carrierInfo.carrierDate }} {{ $store.state.carrierInfo.carrierTimeFrom }} - {{ $store.state.carrierInfo.carrierTimeTo }}
                    </b>
                    <b class="d-block mt-2">
                        <span style="color:#B35C00;" v-html="$helper.trans('Register_pick_up_address')"></span>
                        <i class="fa fa-question-circle info-question-circle position-absolute" style="position: relative !important;">
                            <div class="custom-popover-wrapper">
                                <div  class="custom-popover alert alert-secondary" v-html="$helper.trans('Register_pick_up_address_info')"></div>
                            </div>
                        </i>
                    </b>
                    <p v-if="!$store.state.carrierInfo.multiPickUpAddresses" class="d-block">{{ $store.state.carrierInfo.pickupAddress }}</p>
                    <span v-else-if="$store.state.carrierInfo.multiPickUpAddresses" class="d-block mt-2">
                        <label v-for="(value, pickUpCode) in $store.state.carrierInfo.pickUpAddresses" :key="pickUpCode" class="custom-radio-wrap">
                            {{ value }}
                            <input type="radio" v-model="$store.state.carrierInfo.pickUpCode" :value="pickUpCode">
                            <span class="checkmark"></span>
                        </label>
                        <span class="carrierInfo_pickUpCode_input"></span>
                    </span>
                </label>
            </div>         
        </div>
        <div class="notification bg-grey spacer-40" style="display: block; margin-bottom: 20px;" v-show="$store.state.carrierInfo.callCarrier === 0">
            <div class="content">
                <!-- <h3>{{ $helper.trans('UPS_office_addresses') }}:</h3> -->
                <div v-html="$store.state.$siteSettings['office_addresses']" style="color:#90867f;"></div>   
            </div>
        </div>        
        <div class="packet-row packet-column" v-show="[1, 2].includes($store.state.carrierInfo.callCarrier)">
            <div class="option-content">
                <label for="address-different" class="custom-checkbox-wrap">
                    {{ $helper.trans('Pickup_address_does_not_match_the_shipping_address') }}
                    <input 
                        type="checkbox" 
                        v-model="$store.state.carrierInfo.differentAddress" 
                        :value="1" id="address-different"
                        @click="changeCourierPickUp"
                    >
                    <span class="checkmark"></span>
                </label>
            </div>
            <div class="notification d-block bg-red spacer-16" style="padding: 20px 20px 0;margin-bottom: 20px;" v-if="$store.state.carrierInfo.differentAddress">                
                <p>{{ $helper.trans('If_choose_different_address_pickup_time_may_change') }}</p>                    
            </div>           

            <div class="additional-fields mt-1" style="display: block; padding: 32px;" v-show="$store.state.carrierInfo.differentAddress">
                <label class="strong-label label-margin" style="margin-bottom: 10px !important;">{{ $helper.trans('Courier_arrival_address') }}:</label>
                <div class="row mr-md-5 mr-2">
                    <div class="col-12 col-md-6 pl-0 pr-1">
                        <div class="mt-2">
                            <input type="text" v-model="$store.state.carrierInfo.differentAddressInfo.address1" :placeholder="'* '+$helper.trans('Address')+' 1'" class="input-big w-100 mt-2 carrierInfo_differentAddressInfo_address1_input"/>
                        </div>
                        <div class="mt-2">
                            <input type="text" v-model="$store.state.carrierInfo.differentAddressInfo.address2" :placeholder="$helper.trans('Address')+' 2'" class="input-big w-100 mt-2 carrierInfo_differentAddressInfo_address2_input"/>
                        </div>
                        <div class="mt-2">
                            <input type="text" v-model="$store.state.carrierInfo.differentAddressInfo.address3" :placeholder="$helper.trans('Address')+' 3'" class="input-big w-100 mt-2 carrierInfo_differentAddressInfo_address3_input"/>
                        </div>
                        <div class="mt-2">
                            <input type="text" v-model="$store.state.carrierInfo.differentAddressInfo.phone" :placeholder="'* ' +$helper.trans('Phone')" class="input-big w-100 mt-2 carrierInfo_differentAddressInfo_phone_input"/>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 pl-1 pr-0">
                        <div class="mt-2">
                            <input type="text" :value="$store.state.from.countryName" class="input-big w-100 mt-2" disabled/>
                        </div>
                        <div class="mt-2">
                            <input type="text" 
                                v-model="$store.state.carrierInfo.differentAddressInfo.postCode" 
                                @blur="getPickupTime()" 
                                @input="$helper.validatePostCode($store.state.carrierInfo.differentAddressInfo.postCode, 'lt', 'carrier_info_post_code');" 
                                :placeholder="'* '+$helper.trans('Zip_code')" 
                                class="input-big w-100 mt-2 carrierInfo_differentAddressInfo_postCode_input"
                                id="carrier_info_post_code"
                            />
                        </div>
                        <div class="mt-2">
                            <input type="text" v-model="$store.state.carrierInfo.differentAddressInfo.city" :placeholder="'* '+$helper.trans('City')" class="input-big w-100 mt-2 carrierInfo_differentAddressInfo_city_input"/>
                        </div>
                        <div class="mt-2" v-show="$store.state.from.country === 'us'">
                            <select2-component
                                :values="$store.state.$siteSettings['State_list']"
                                :placeholder="'* '+$helper.trans('State')"
                                classes="input-big select-style-ups select2-vue carrierInfo_differentAddressInfo_stateOrProvince_input"
                                v-model="$store.state.carrierInfo.differentAddressInfo.stateOrProvince"
                            ></select2-component>
                        </div>
                        <div class="mt-2" v-show="$store.state.from.country === 'ca'">
                            <select2-component
                                :values="$store.state.$siteSettings['Province_list']"
                                :placeholder="'* '+$helper.trans('Province')"
                                classes="input-big select-style-ups select2-vue carrierInfo_differentAddressInfo_stateOrProvince_input"
                                v-model="$store.state.carrierInfo.differentAddressInfo.stateOrProvince"
                            ></select2-component>
                        </div>
                        <div class="mt-2" v-show="$store.state.from.country === 'ie'">
                            <select2-component
                                :values="$store.state.$siteSettings['Counties_list']"
                                :placeholder="'* '+$helper.trans('County')"
                                classes="input-big select-style-ups select2-vue carrierInfo_differentAddressInfo_stateOrProvince_input"
                                v-model="$store.state.carrierInfo.differentAddressInfo.stateOrProvince"
                            ></select2-component>
                        </div>
                        <div class="mt-2" v-show="$store.state.from.country === 'au'">
                            <select2-component
                                :values="$store.state.$siteSettings['AU_state_list']"
                                :placeholder="'* '+$helper.trans('State')"
                                classes="input-big select-style-ups select2-vue carrierInfo_differentAddressInfo_stateOrProvince_input"
                                v-model="$store.state.carrierInfo.differentAddressInfo.stateOrProvince"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{ 'disable-block': $store.state.carrierInfo.callCarrier === 2 }">
            <div class="packet-row packet-column" id="ups-carrier" v-show="[1, 2].includes($store.state.carrierInfo.callCarrier)">
                <label class="strong-label">{{ $helper.trans('Courier_arrival_time') }}:</label>
                <div class="option-content option-content-row full-width row-small">
                    <div class="option-column column-space-small datepicker-container">
                        <input id="carrier_datepicker"
                            type="text" 
                            :placeholder="$helper.trans('Pickup_date')" 
                            class="input-big js_form-input carrierInfo_carrierDate_input"
                            v-model="$store.state.carrierInfo.carrierDate"
                            :data-custom-datepicker-settings="JSON.stringify(datepickerCustomSettings)"
                        >
                    </div>
                    <div class="option-column column-space-small column-6">
                        <div class="inside-row row-small">
                            <div class="column-6 column-space-small">
                                <select2-component
                                    :values="pickUpStartTimesArray"
                                    :placeholder="$helper.trans('Pickup_time_start')"
                                    :noLang="true"
                                    classes="input-big select-style-ups carrierInfo_carrierTimeFrom_input"
                                    v-model="$store.state.carrierInfo.carrierTimeFrom"
                                    specialName="carrierPickupTimeStart"
                                ></select2-component>
                            </div>
                            <div class="column-6 column-space-small">
                                <select2-component
                                    :values="pickUpEndTimesArray"
                                    :placeholder="$helper.trans('Pickup_time_end')"
                                    :noLang="true"
                                    classes="input-big select-style-ups carrierInfo_carrierTimeTo_input"
                                    v-model="$store.state.carrierInfo.carrierTimeTo"
                                    specialName="carrierPickupTimeEnd"
                                ></select2-component>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="packet-row packet-column packet-checkbox packet-line" style="border-top: 1px solid #DDD7D0; padding-top: 40px;">
                <div class="option-content full-width option-upload-content carrierInfo_invoiceDeliveryType_input">
                    <label for="get-pdf" class="custom-radio-wrap">
                        {{ $helper.trans('Get_pdf_ticket') }}
                        <input type="radio" v-model="$store.state.carrierInfo.invoiceDeliveryType" value="pdf" id="get-pdf">
                        <span class="checkmark"></span>
                    </label>                                       
                    <label for="get-ticket" class="custom-radio-wrap" v-if="[1, 2].includes($store.state.carrierInfo.callCarrier)">
                        {{ $helper.trans('Courier_will_bring_ticket') }}
                        <input type="radio" v-model="$store.state.carrierInfo.invoiceDeliveryType" value="carrier" id="get-ticket">
                        <span class="checkmark"></span>
                    </label>
                </div>
            </div>
            <div class="packet-row packet-column packet-textarea" v-if="[1, 2].includes($store.state.carrierInfo.callCarrier)">
                <label class="strong-label">{{ $helper.trans('Additional_notes_for_courier') }}</label>
                <textarea class="carrierInfo_notesToCarrier_input" v-model="$store.state.carrierInfo.notesToCarrier" :placeholder="$helper.trans('Door_code_specifying_how_to_find_address')"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    data: function(){
        return {
            timeStep: 10, // In minutes
            datepickerCustomSettings:{
                minDate: '',
                noWeekends: true,                
            }
        };
    },
    created: async function(){
        let vueThis = this;
        
        vueThis.datepickerCustomSettings.minDate = moment().format('YYYY-MM-DD');

        if (vueThis.$store.state.from.country === 'lt') {
            vueThis.datepickerCustomSettings.holidays =
                [
                    new Date(new Date().getFullYear() + '-01-01'),
                    new Date(new Date().getFullYear() + '-02-16'),        
                    new Date(new Date().getFullYear() + '-03-11'),
                    window.getEasterDate(new Date().getFullYear()),
                    new Date(new Date().getFullYear() + '-05-01'),
                    new Date(new Date().getFullYear() + '-06-24'),
                    new Date(new Date().getFullYear() + '-07-06'),
                    new Date(new Date().getFullYear() + '-08-15'),
                    new Date(new Date().getFullYear() + '-11-01'),
                    new Date(new Date().getFullYear() + '-12-24'),
                    new Date(new Date().getFullYear() + '-12-25'),
                    new Date(new Date().getFullYear() + '-12-26')
                ];
        }  
        
        vueThis.$nextTick(function(){
            setTimeout(function(){
                $('#carrier-parent').on('show.bs.collapse', function(){
                    vueThis.getPickupTime();
                });
            }, 250);
        });
    },
    beforeDestroy() {
        $('#carrier-parent').off('show.bs.collapse');
    },
    methods: {
        getMinutesFromHours: function(hours){
            let hoursSplit = hours.split(':');
            return parseInt(hoursSplit[1]) + parseInt(hoursSplit[0]) * 60; 
        },
        getHoursFromMinutes: function(minutes){
            let minutesPart = Math.round(minutes % 60);
            return Math.floor(minutes/60).toString().padStart(2, '0')+':'+minutesPart.toString().padStart(2, '0');
        },
        createTimesArray: function(earliestTimeInt, latestTimeInt){
            let times = {};
            if(earliestTimeInt <= latestTimeInt){
                let currentTimeInt = earliestTimeInt;
                let currentTimeHours = this.getHoursFromMinutes(currentTimeInt);
                while(currentTimeInt <= latestTimeInt){
                    times[currentTimeHours] = currentTimeHours.toString();
                    currentTimeInt += this.timeStep;
                    currentTimeHours = this.getHoursFromMinutes(currentTimeInt);
                }
            }
            return times;
        },
        getPickupTime: async function(){
            let vueThis = this;
            let postCode = vueThis.$store.state.from.postCode;
            if(vueThis.$store.state.carrierInfo.differentAddress){
                postCode = vueThis.$store.state.carrierInfo.differentAddressInfo.postCode;
            }
            
            vueThis.$store.state.pickupInformation.country = vueThis.$store.state.from.country;
            vueThis.$store.state.pickupInformation.postCode = postCode;

            if(vueThis.$store.state.from.country !== 'lt'){
                vueThis.setEmptyPickupTimes();
                return;
            }

            let url = vueThis.$store.state.$routes['api.get_pickup_times_by_code'];
            let data = {
                postCode: postCode
            };

            await axios.post(url, data)
            .then(function(response){
                if(!response.data){
                    vueThis.setEmptyPickupTimes();
                    return;
                }

                vueThis.$store.state.pickupInformation.latestOrderTime = response.data.latestOrderTime;
                vueThis.$store.state.pickupInformation.earliestPickupTime = response.data.earliestPickupTime;
                vueThis.$store.state.pickupInformation.latestPickupTime = response.data.latestPickupTime;
                vueThis.$store.state.pickupInformation.minimumInterval = response.data.minimumInterval;
                vueThis.$store.state.pickupInformation.mustUseCarrierSticker = response.data.mustUseCarrierSticker;
            }).catch(function(error){
                console.error(error);
            }).finally(function(){
                vueThis.setMinDateForCarrier();
            });
        },
        setEmptyPickupTimes: function(){
            if(this.$store.state.returnedBackFromPayment){
                return;
            }
            this.$store.state.pickupInformation.mustUseCarrierSticker = false;
            this.$store.state.pickupInformation.latestOrderTime = '00:00';
            this.$store.state.pickupInformation.earliestPickupTime = moment().add(5, 'minutes').format('HH:mm');
            this.$store.state.pickupInformation.latestPickupTime = moment(this.$store.state.selectedShippingOption.estimatedPickup).format('HH:mm');
            this.$store.state.pickupInformation.minimumInterval = '02:00';
            this.$store.state.carrierInfo.carrierDate = moment().format('YYYY-MM-DD');

            if(moment(this.$store.state.selectedShippingOption.estimatedPickup).format('HHmm') <= moment().add(150, 'minutes').format('HHmm')){
                this.$store.state.carrierInfo.carrierDate = moment().add(1, 'days').format('YYYY-MM-DD');
                this.$store.state.pickupInformation.earliestPickupTime = '10:00';
            }

            this.setMinDateForCarrier();
        },
        setMinDateForCarrier: function(){
            let vueThis = this;
            if($('#carrier_datepicker').data('daterangepicker')){
                $('#carrier_datepicker').data('daterangepicker').remove();
            }

            vueThis.datepickerCustomSettings.minDate = vueThis.minimumCarrierDate;
            vueThis.$nextTick(function(){
                window.initDatePicker($('#carrier_datepicker'));
                $('#carrier_datepicker').on('change', function(){;
                    vueThis.$store.state.carrierInfo.carrierDate = $(this).val();
                });
            });
        },
        getNextAvailableDay: function(today){
            let momentToday = moment(today).add(1, 'day');
            if(momentToday.isoWeekday() >= 6){
                momentToday = momentToday.startOf('isoWeek').add(1, 'week');
            }
            return momentToday.format('YYYY-MM-DD');
        },
        changeCourierPickUp: function() {
            this.$store.state.carrierInfo.callCarrier = 1;
        },
    },
    computed: {
        minimumCarrierDate: function(){
            let today = moment().format('YYYY-MM-DD');
            let nextAvailableDay = this.getNextAvailableDay(today);

            if(this.$store.state.returnedBackFromPayment){
                // this.datepickerCustomSettings.minDate = nextAvailableDay;       
                // return nextAvailableDay;
            }

            if(today < (this.$store.state.selectedShippingOption.earliestPickupDate || today)){
                this.$store.state.carrierInfo.carrierDate = this.$store.state.selectedShippingOption.earliestPickupDate;
                return this.$store.state.selectedShippingOption.earliestPickupDate;
            } 

            if(this.$store.state.carrierInfo.invoiceDeliveryType === 'carrier'){
                return nextAvailableDay;
            }

            let latestOrderTime = this.getMinutesFromHours(this.$store.state.pickupInformation.latestOrderTime);
            if(latestOrderTime < this.getMinutesFromHours(moment().format('HH:mm'))){
                return nextAvailableDay;
            }

            return today;
        },
        pickUpStartTimesArray(){
            let vueThis = this;

            let minimumIntervalInt = vueThis.getMinutesFromHours(vueThis.$store.state.pickupInformation.minimumInterval);
            let earliestTimeInt = vueThis.getMinutesFromHours(vueThis.$store.state.pickupInformation.earliestPickupTime);
            let latestTimeInt = vueThis.getMinutesFromHours(vueThis.$store.state.pickupInformation.latestPickupTime) - minimumIntervalInt;
        
            if(vueThis.minimumCarrierDate === moment().format('YYYY-MM-DD')){
                earliestTimeInt = Math.max(vueThis.getMinutesFromHours(moment().add(5, 'minutes').format('HH:mm')), earliestTimeInt);
            }

            earliestTimeInt = Math.ceil(earliestTimeInt/10)*10;
        
            let times = vueThis.createTimesArray(earliestTimeInt, latestTimeInt);

            vueThis.$nextTick(function(){
                if(!Object.values(times).includes(vueThis.$store.state.carrierInfo.carrierTimeFrom)){
                    vueThis.$store.state.carrierInfo.carrierTimeFrom = Object.values(times)[0] || null;
                }
            });

            return times;
        },
        pickUpEndTimesArray(){
            let vueThis = this;

            if(empty(vueThis.$store.state.carrierInfo.carrierTimeFrom)){
                vueThis.$store.state.carrierInfo.carrierTimeTo = null;
                return {};
            }

            let minimumIntervalInt = vueThis.getMinutesFromHours(vueThis.$store.state.pickupInformation.minimumInterval);
            let earliestTimeInt = vueThis.getMinutesFromHours(vueThis.$store.state.carrierInfo.carrierTimeFrom) + minimumIntervalInt;
            let latestTimeInt = vueThis.getMinutesFromHours(vueThis.$store.state.pickupInformation.latestPickupTime);

            earliestTimeInt = Math.ceil(earliestTimeInt/10)*10;

            let times = vueThis.createTimesArray(earliestTimeInt, latestTimeInt);

            vueThis.$nextTick(function(){
                if(!Object.values(times).includes(vueThis.$store.state.carrierInfo.carrierTimeTo)){
                    vueThis.$store.state.carrierInfo.carrierTimeTo = Object.values(times).slice(-1)[0] || null;
                }
            });

            return times;
        },
    },
    watch:{
        '$store.state.carrierInfo': {
            handler(newValue) {
                this.$store.state.sessionStartTime = this.$helper.getSessionStartTime();
                this.$store.state.checkOutSteps.six = false;
                $('.carrierInfo_carrierDate_input').removeClass('alert-danger-ups').parent().removeClass('custom-ups-error-parent');  
                $('.carrierInfo_carrierTimeFrom_input').removeClass('alert-danger-ups').parent().removeClass('custom-ups-error-parent');  
                $('.carrierInfo_carrierTimeTo_input').removeClass('alert-danger-ups').parent().removeClass('custom-ups-error-parent');  
            },
            deep: true
        },
        '$store.state.carrierInfo.callCarrier': function(){   
            if (this.$store.state.carrierInfo.callCarrier === 2) {
                this.$store.state.carrierInfo.differentAddress = false;
            }         
            this.getPickupTime();
        },
        '$store.state.carrierInfo.differentAddress': function(){
            this.getPickupTime();
        },
        minimumCarrierDate: function(){
            if(this.minimumCarrierDate > this.$store.state.carrierInfo.carrierDate){
                this.$store.state.carrierInfo.carrierDate = this.minimumCarrierDate;
            }
            this.setMinDateForCarrier();
        },
        '$store.state.pickupInformation.mustUseCarrierSticker': function(value){
            if(value){
                this.$store.state.carrierInfo.invoiceDeliveryType = 'carrier';
            }
        },
        '$store.state.carrierInfo.notesToCarrier': function(newValue, oldValue){
            if(this.$store.state.carrierInfo.invoiceDeliveryType !== 'carrier' || this.$store.state.carrierInfo.notesToCarrier.startsWith('ATVEŽTI BILIETĄ \n')){
                return;
            }

            if(oldValue.search('ATVEŽTI BILIETĄ \n') === -1){
                this.$store.state.carrierInfo.notesToCarrier = 'ATVEŽTI BILIETĄ \n' + oldValue;
                return;
            } 

            this.$store.state.carrierInfo.notesToCarrier = oldValue;
        },
        '$store.state.carrierInfo.invoiceDeliveryType': function(){
            if(this.$store.state.carrierInfo.invoiceDeliveryType === 'carrier'){
                this.$store.state.carrierInfo.notesToCarrier = 'ATVEŽTI BILIETĄ \n' + this.$store.state.carrierInfo.notesToCarrier;
                return;
            } 
             
            this.$store.state.carrierInfo.notesToCarrier = this.$store.state.carrierInfo.notesToCarrier.replace('ATVEŽTI BILIETĄ \n', '');
        },
    },
}
</script>
